import styled from '@emotion/styled'
import { css } from '@emotion/react'

const addressWrapperStyles = ({ theme }) => css`
  label: address-wrapper;

  background-color: #F8F8F8;

  padding: ${theme.spacings.kilo};
  margin-bottom: ${theme.spacings.byte};
`

export const AddressWrapper = styled('div')(addressWrapperStyles)
